function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.44864 0.534058C3.55501 2.04808 0 6.60881 0 11.9999C0 17.3908 3.55488 21.9515 8.44836 23.4656C5.68541 20.4426 4 16.4181 4 12C4 7.58168 5.68552 3.55707 8.44864 0.534058Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.44864 0.534058C3.55501 2.04808 0 6.60881 0 11.9999C0 17.3908 3.55488 21.9515 8.44836 23.4656C5.68541 20.4426 4 16.4181 4 12C4 7.58168 5.68552 3.55707 8.44864 0.534058Z",
  fill: "#5D5D5D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.44864 0.534058L9.18677 1.20872L11.6716 -1.50985L8.15308 -0.421266L8.44864 0.534058ZM8.44836 23.4656L8.15278 24.4209L11.6713 25.5096L9.1865 22.7909L8.44836 23.4656ZM1 11.9999C1 7.05957 4.25753 2.8775 8.74421 1.48938L8.15308 -0.421266C2.85249 1.21866 -1 6.15805 -1 11.9999H1ZM8.74395 22.5103C4.2574 21.1221 1 16.9401 1 11.9999H-1C-1 17.8416 2.85235 22.7809 8.15278 24.4209L8.74395 22.5103ZM9.1865 22.7909C6.58539 19.945 5 16.1588 5 12H3C3 16.6774 4.78543 20.9402 7.71023 24.1402L9.1865 22.7909ZM5 12C5 7.84101 6.5855 4.05466 9.18677 1.20872L7.71052 -0.140609C4.78555 3.05947 3 7.32235 3 12H5Z",
  fill: "#5D5D5D",
  mask: "url(#path-1-inside-1)"
});

var SvgRating1 = function SvgRating1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 24,
    viewBox: "0 0 9 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRating1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Rating1.500d3b16.svg";
export { ForwardRef as ReactComponent };